/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const wikiquotePageResultSchema = z.object({
  pageId: z.number(),
  title: z.string(),
  snippet: z.string(),
});

export type IWikiquotePageResult = z.infer<typeof wikiquotePageResultSchema>;

export const searchWikiquotePagesV1ResponseSchema = createApiResponseSchema(
  z.array(wikiquotePageResultSchema),
) as import('zod').ZodSchema<IAPI<IWikiquotePageResult[]>>;

export type ISearchWikiquotePagesV1Response = IAPI<IWikiquotePageResult[]>;
